<template>
  <v-layout class="rounded rounded-md">
    <v-app-bar elevation="0" class="border-b">
      <v-row justify="space-between" no-gutters>
        <v-list-item>
          <v-row align="center" no-gutters>
            <v-btn
              icon="mdi-menu"
              variant="text"
              class="me-4"
              @click.stop="drawer = !drawer"
            >
            </v-btn>
            <v-img height="48px" width="106px" src="/images/logo.png" />
          </v-row>
        </v-list-item>
        <v-list-item>
          <v-row align="center" no-gutters>
            <v-btn icon="mdi-bell-outline"></v-btn>
            <v-list-item
              :title="useUserStore().user.firstName.split(' ')[0]"
              subtitle="Peserta"
            >
              <template v-slot:prepend>
                <v-avatar color="grey-lighten-3"></v-avatar>
              </template>
              <template v-slot:append> </template>
            </v-list-item>
          </v-row>
        </v-list-item>
      </v-row>
    </v-app-bar>
    <v-navigation-drawer
      v-model="drawer"
      class="border-0 bg-white pt-4"
      width="300"
      elevation="3"
    >
      <v-list v-model:opened="open">
        <template v-for="(menu, menuId) in menuInfo" :key="menuId">
          <!-- #1 -->
          <v-list-item
            v-if="!menu.childs"
            :class="isActiveMenu === menu.path ? 'text-red-darken-4' : ''"
            @click="
              menu.title === 'Logout'
                ? logoutBelajarMandiri()
                : clickMenu(menu.path)
            "
          >
            <v-icon :icon="`mdi-${menu.icon}`" class="mr-3" />
            {{ menu.title }}
          </v-list-item>
          <!-- END #1 -->
          <v-list-group v-else :value="menu.title.replace(/\s+/g, '')">
            <!-- #2 -->
            <template v-slot:activator="{ props }">
              <v-list-item v-bind="props">
                <v-icon :icon="`mdi-${menu.icon}`" class="mr-3" />
                {{ menu.title }}
              </v-list-item>
            </template>
            <template v-for="(child) in menu.childs">
              <v-list-item
                v-if="!child.childs"
                :class="isActiveMenu === child.path ? 'text-red-darken-4' : ''"
                @click="clickMenu(child.path)"
              >
                <v-icon icon="mdi-circle-medium" class="mr-3" />
                {{ child.title }}
              </v-list-item>
              <v-list-group v-else :value="child.title.replace(/\s+/g, '')">
                <!-- #3 -->
                <template v-slot:activator="{ props }">
                  <v-list-item v-bind="props">
                    <v-icon icon="mdi-circle-medium" class="mr-3" />
                    <span class="">{{ child.title }}</span>
                  </v-list-item>
                </template>
                <template v-for="(child2) in child.childs">
                  <v-list-item
                    :class="isActiveMenu === child2.path ? 'text-red-darken-4' : ''"
                    @click="clickMenu(child2.path)"
                  >
                    <v-icon icon="mdi-circle-medium" class="mr-3" />
                    {{ child2.title }}
                  </v-list-item>
                </template>
                <!-- END #3 -->
              </v-list-group>
            </template>
            <!-- END #2 -->
          </v-list-group>
        </template>
      </v-list>
      <NotifikasiTugas />
      <template v-slot:append>
        <v-divider></v-divider>
        <div class="text-center pa-2 text-caption">
          Pembelajaran Mandiri
          <div class="text-medium-emphasis">
            Lembaga Administrasi Negara — {{ new Date().getFullYear() }}
          </div>
        </div>
      </template>
    </v-navigation-drawer>
    <v-main class="bg-grey-lighten-5">
      <Chat />
      <NuxtPage
        style="min-height: calc(var(--vh, 1vh) * 100)"
      ></NuxtPage>
    </v-main>
  </v-layout>
</template>

<script>
import Chat from "~/components/pembelajaran_wajib/terjadwal/Chat.vue";
import NotifikasiTugas from "@/components/pim_ui/Peserta/NotifikasiTugas.vue";

export default {
  components: {
    NotifikasiTugas,
    Chat
  },
  data() {
    return {
      drawer: null,
      open: [],
      isActiveMenu: useRoute().path || "/",
      menuInfo: [
        {
          title: "Dashboard",
          path: "/pim/Peserta",
          icon: "view-dashboard-outline",
        },
        {
          title: "Agenda Pembelajaran",
          path: "/pim/Peserta/Agenda-Pembelajaran",
          icon: "view-agenda-outline",
        },
        // {
        //   title: "Pelatihan",
        //   path: "#",
        //   icon: "school-outline",
        //   childs: [
        //     {
        //       title: "Data Pelatihan",
        //       path: "/pim/Peserta/Pelatihan/DataPelatihan",
        //     },
        //     {
        //       title: "Pelatihan Berjalan",
        //       path: "/pim/Peserta/Pelatihan/PelatihanBerjalan",
        //     },
        //     {
        //       title: "Pelatihan Selesai",
        //       path: "/pim/Peserta/Pelatihan/PelatihanSelesai",
        //     },
        //   ]
        // },
        // {
        //   title: "Data",
        //   path: "#",
        //   icon: "database-outline",
        //   childs: [
        //     {
        //       title: "Master Data",
        //       path: "/pim/Peserta/Data/MasterData",
        //     },
        //     {
        //       title: "Master Data Administrator",
        //       path: "#",
        //       childs: [
        //         {
        //           title: "Data PIC",
        //           path: "/pim/Peserta/Data/MasterDataAdministrator/DataPIC",
        //         },
        //         {
        //           title: "Data Admin",
        //           path: "/pim/Peserta/Data/MasterDataAdministrator/DataAmin",
        //         },
        //       ]
        //     },
        //     {
        //       title: "Referensi",
        //       path: "/pim/Peserta/Data/Referensi",
        //     },
        //   ]
        // },
        // {
        //   title: "Beranda Pengaturan",
        //   path: "#",
        //   icon: "cog-outline",
        //   childs: [
        //     {
        //       title: "Pengaturan Umum",
        //       path: "/pim/BerandaPengaturan/PengaturanUmum",
        //     },
        //     {
        //       title: "Pengaturan Peserta",
        //       path: "/pim/BerandaPengaturan/PengaturanPeserta",
        //     },
        //     {
        //       title: "Pengaturan Pelatihan",
        //       path: "/pim/BerandaPengaturan/PengaturanPelatihan",
        //     },
        //   ]
        // },
        {
          title: "Logout",
          path: "",
          icon: "logout",
        },
      ],
    };
  },
  mounted() {
    const pathParts = useRoute().path.split("/");
    pathParts.pop();
    this.open.push(...pathParts.slice(-2));
  },
  methods: {
    clickMenu(menu) {
      navigateTo({ path: menu });
      this.isActiveMenu = menu;
    },
    logoutBelajarMandiri() {
      return navigateTo({ path: "/login" });
    },
  },
  computed: {
    userInfo() {
    },
  },
};
</script>
<style>
.chat-button {
  position: fixed;
  bottom: 5px;
  right: 5px;
  z-index: 9;
}
.v-data-table.bm-table .v-table__wrapper > table > thead > tr > th {
  background-color: #eeeeee;
}
</style>
